<template>
    <div>
        <app-datatable
            :items="data"
            :headers="headers"
            :hasDownload="true"
            :has-custom-pagination="true"
            :has-custom-search="true"
            :hasMultiSearch="true"
            :custom-pagination-current-page="pagination.currentPage"
            :custom-pagination-per-page="pagination.perPage"
            :custom-pagination-total-pages="total_pages"
            :custom-pagination-total-items="total"
            :custom-pagination-sort-mode="pagination.sortMode"
            v-on:selected="selectedRow = $event"
            v-on:dblClicked="selectedRowData($event)"
            v-on:changePage="
                pagination = { ...pagination, currentPage: $event }
            "
            v-on:changeSortMode="
                pagination = { ...pagination, sortMode: $event }
            "
            v-on:doSearch="
                filters = $event;
                doSearch();
            "
            v-on:deleteOnFilter="delByOneFilter($event)"
            style="cursor: pointer !important"
        ></app-datatable>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import { mapState } from "vuex";
import axios from "axios";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            token: JSON.parse(localStorage.getItem("token")).value,
            isLoading: false,
            selectedRow: null,
            total: 0,
            total_pages: 0,
            start_date: "",
            end_date: "",
            search: "",
            tableKey: "",
            sortBy: "",
            filters: "",
            pagination: {
                perPage: 25,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            data: [],
            problem: [],
            total_problem: 0,
            headers: [
                { text: "Nama Program", value: "name" },
                { text: "Pemilik Kemitraan", value: "owner_name" },
                { text: "Partner", value: "partner_name" },
                { text: "Deskripsi", value: "description" },
            ],
            filter_type: "ALL",
            menu: false,
            modal_date: false,
            modal_date2: false,
            filters: [],
            params: {
                nama: "",
            },
        };
    },

    watch: {
        pagination() {
            this.fetchData();
        },
    },

    mounted: function () {
        this.fetchData();
    },

    computed: {
        ...mapState(["auth"]),
    },

    methods: {
        fetchData() {
            const context = this;

            if (context.filters.length > 0) {
                context.filters.forEach((filter, index) => {
                    if (filter.key.value === "name") {
                        context.params.nama = filter.value;
                    }
                });
            }

            const page = context.pagination.currentPage - 1;
            const param = `page=${page}&size=${context.pagination.perPage}&nama=${context.params.nama}`;
            const url = `${process.env.API_BASE_URL}partnership/admin/programs?${param}`;
            context.isLoading = true;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            context.data = [];
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    response.data.list_program.forEach(
                        function (content, index) {
                            var row = {
                                no: index,
                                id: content.id,
                                name: content.name,
                                owner_name: content.owner_name,
                                partner_name: content.partner_name,
                                description: content.description,
                            };

                            context.data.push(row);
                        },
                    );

                    context.total = response.data.total_program;
                    context.total_pages = response.data.max_page;
                }
                context.isLoading = false;
            });
        },
        doSearch() {
            var context = this;
            context.pagination.currentPage = 1;
            this.fetchData();
        },
        delByOneFilter(filter) {
            this.clearFilter();
            filter.value = "";

            const index = this.filters.push(filter) - 1;
            this.fetchData();
            this.filters.splice(index, 1);
        },
        clearFilter() {
            this.params = {
                nama: null,
            };
        },
        selectedRowData(item) {
            this.$emit("selectedRow", item);
        },
    },
};
</script>



// WEBPACK FOOTER //
// PartnershipProgramDialog.vue?45379608